import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalFeePaymentManualWizardService } from 'src/app/services/medical-fee/medical-fee-payment-manual-wizard.service';
import { MedicalFeeReportDialogComponent } from '../../dialogs/medical-fee-report-dialog/medical-fee-report-dialog.component';
import { MedicalFeePaymentManualAmountComponent } from '../medical-fee-payment-manual-amount/medical-fee-payment-manual-amount.component';
import { MedicalFeePaymentAliquotComponent } from '../medical-fee-payment-aliquot/medical-fee-payment-aliquot.component';
import { MedicalFeePaymentAmountComponent } from '../medical-fee-payment-amount/medical-fee-payment-amount.component';

@Component({
  selector: 'app-medical-fee-payment-manual-wizard',
  templateUrl: './medical-fee-payment-manual-wizard.component.html',
  styleUrls: ['./medical-fee-payment-manual-wizard.component.css'],
  providers: [ MedicalFeePaymentManualWizardService ]
})
export class MedicalFeePaymentManualWizardComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  @ViewChild('medicalFeePaymentAmount', {static: false}) medicalFeePaymentAmount: MedicalFeePaymentAmountComponent;
  @ViewChild('medicalFeePaymentAliquot', {static: false}) medicalFeePaymentAliquot: MedicalFeePaymentAliquotComponent;

  constructor( private dialog: MatDialog,
               private notificationToastService: NotificationToastService,
               private mfpWizardService: MedicalFeePaymentManualWizardService ) { }

  async ngOnInit() {

    try {

      this.loading = true;
      await this.mfpWizardService.init( );

    } catch ( err ) {

      this.notificationToastService.error( JSON.stringify( err.error ), 'Honorarios' );
    } finally {

      this.loading = false;
    }
  }

  selectedIndexChange(newIndex: number) {

    if ( newIndex === 1 ) {

      this.medicalFeePaymentAliquot
      .realoadIfRequired( this.mfpWizardService.getPhysicianId() );
    }
 }

  cancel() {

    history.back();
  }

  async viewReport() {

    try {

      if ( this.medicalFeePaymentAmount.isValid() ) {

        this.loadingAction = true;
        const reportViewer = await this.mfpWizardService.createReport();

        const dialog = this.dialog.open(MedicalFeeReportDialogComponent, {
          width: '90%',
          height: '600px',
          data: reportViewer
        });

        dialog.afterClosed().subscribe( async (value) => {
            if ( value ) {
              await this.createMedicalFeeBill();
            }
        });

      }
    } catch (err) {

      this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
    } finally {

      this.loadingAction = false;
    }
  }

  private async createMedicalFeeBill() {

    try {

      this.loadingAction = true;

      await this.mfpWizardService.createMedicalFeeBill();
      this.notificationToastService.success('Se liquidaron los honorarios correctamente', 'Honorarios');
      this.cancel();

    } catch ( err ) {

      console.log( err );
      this.notificationToastService.error( JSON.stringify( err.error ), 'Honorarios' );
    } finally {

      this.loadingAction = false;
    }
  }
}
